import { call, takeLatest, put, delay } from 'redux-saga/effects';
import { type } from './type';
import { getUserInit, getVideoList } from './axios';

function* watch_getUserInit(action: any) {
    try {
        yield put({
            type: type.USER_VIEW_ONLY_INIT_ASYNC,
            is_loading: true,
        });
        const data = yield call(getUserInit, action);
        yield put({
            type: type.USER_VIEW_ONLY_INIT_ASYNC,
            data: data.data,
            is_loading: false,
        });
    } catch (error) {
        throw error;
    }
}

function* watch_getVideoList(action: any) {
    try {
        yield put({
            type: type.GET_TEACHER_VIDEO_VIEW_ONLY_LIST_ASYNC,
            is_loading: true,
        });
        const data = yield call(getVideoList, action);
        yield put({
            type: type.GET_TEACHER_VIDEO_VIEW_ONLY_LIST_ASYNC,
            data: data.data,
            status: data.status,
            is_loading: false,
            total_records: data.total_records,
            total_retrieved: data.total_retrieved,
        });
    } catch (error) {
        throw error;
    }
}

export function* watchUserSagas() {
    yield takeLatest(type.USER_VIEW_ONLY_INIT, watch_getUserInit);
    yield takeLatest(type.GET_TEACHER_VIDEO_VIEW_ONLY_LIST, watch_getVideoList);
}
